module.exports = __webpack_public_path__ + "img/frances-gunn-QcBAZ7VREHQ-unsplash.30c2c513.jpg";